var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMerge(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 4,
    viewBox: "0 0 14 4",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 2.09961C0 1.82347 0.223858 1.59961 0.5 1.59961H13.5C13.7761 1.59961 14 1.82347 14 2.09961C14 2.37575 13.7761 2.59961 13.5 2.59961H0.5C0.223857 2.59961 0 2.37575 0 2.09961Z",
    fill: "#0A28AB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3 2C3 0.895431 3.89543 0 5 0C6.10457 0 7 0.895431 7 2C7 3.10457 6.10457 4 5 4C3.89543 4 3 3.10457 3 2Z",
    fill: "#0A28AB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7 2C7 0.895431 7.89543 0 9 0C10.1046 0 11 0.895431 11 2C11 3.10457 10.1046 4 9 4C7.89543 4 7 3.10457 7 2Z",
    fill: "#0A28AB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMerge);
export default __webpack_public_path__ + "res/media/merge.828ac0290e678398a0ba0f745e5e5ca7.svg";
export { ForwardRef as ReactComponent };